import {
  ACDTYPE_TEXT,
  ACDTYPE_TEXT_ONLY,
  ACDTYPE_IMAGE,
  ACDTYPE_VIDEO,
  ACDTYPE_AUDIO,
  ACDTYPE_SEPARATOR,
  ACDTYPE_IMAGE_ONLY,
  ACDTYPE_IMAGE_ARR
} from "./ACDTypes";

import {
  ACSTYPE_TITLE,
  ACSTYPE_SUBTITLE,
  ACSTYPE_CONTRIBUTOR,
  ACSTYPE_INTRO,
  ACSTYPE_SEC_TITLE,
  ACSTYPE_PARAGRAPH,
  ACSTYPE_QUOTE,
  ACSTYPE_IMAGE,
  ACSTYPE_VIDEO,
  ACSTYPE_AUDIO,
  ACSTYPE_SEP,
  ACSTYPE_MAIN_IMG,
  ACSTYPE_GALLERY,
  ACSTYPE_MOSAIC,
  ACSTYPE_PREFACE,
  ACSTYPE_SEC_SUBTITLE
} from "./ACSTypes";

export function getACSTypesForACDType(acdType) {
  switch (acdType) {
    case ACDTYPE_TEXT:
      return [
        ACSTYPE_SEC_TITLE,
        ACSTYPE_SEC_SUBTITLE,
        ACSTYPE_PARAGRAPH,
        ACSTYPE_QUOTE,
        ACSTYPE_PREFACE
      ];
    case ACDTYPE_TEXT_ONLY:
      return [
        ACSTYPE_TITLE,
        ACSTYPE_SUBTITLE,
        ACSTYPE_CONTRIBUTOR,
        ACSTYPE_INTRO
      ];
    case ACDTYPE_IMAGE:
      return [ACSTYPE_IMAGE];
    case ACDTYPE_VIDEO:
      return [ACSTYPE_VIDEO];
    case ACDTYPE_AUDIO:
      return [ACSTYPE_AUDIO];
    case ACDTYPE_SEPARATOR:
      return [ACSTYPE_SEP];
    case ACDTYPE_IMAGE_ONLY:
      return [ACSTYPE_MAIN_IMG];
    case ACDTYPE_IMAGE_ARR:
      return [ACSTYPE_GALLERY, ACSTYPE_MOSAIC];
    default:
      throw Error("unknown data type");
  }
}

export function getACSTypeBg(acsType) {
  switch (acsType) {
    case ACSTYPE_TITLE:
      return null;
    case ACSTYPE_SUBTITLE:
      return null;
    case ACSTYPE_CONTRIBUTOR:
      return null;
    case ACSTYPE_INTRO:
      return null;
    case ACSTYPE_SEC_TITLE:
      return "#FF6B79";
    case ACSTYPE_SEC_SUBTITLE:
      return "#ACDFB7";
    case ACSTYPE_PARAGRAPH:
      return "#FFF0A9";
    case ACSTYPE_QUOTE:
      return "#B4F4FC";
    case ACSTYPE_IMAGE:
      return "#B6A2CD";
    case ACSTYPE_VIDEO:
      return "#C7F1B9";
    case ACSTYPE_AUDIO:
      return "#A66872";
    case ACSTYPE_SEP:
      return null;
    case ACSTYPE_GALLERY:
      return "#114A73";
    case ACSTYPE_MOSAIC:
      return "#FADCF2";
    case ACSTYPE_PREFACE:
      return "#CDDAE5";
    default:
      return null;
  }
}

export function getACSTypeApiText(acsType) {
  switch (acsType) {
    case ACSTYPE_TITLE:
      return "title";
    case ACSTYPE_SUBTITLE:
      return "subtitle";
    case ACSTYPE_CONTRIBUTOR:
      return "contributor";
    case ACSTYPE_INTRO:
      return "intro";
    case ACSTYPE_SEC_TITLE:
      return "h1";
    case ACSTYPE_SEC_SUBTITLE:
      return "h2";
    case ACSTYPE_PARAGRAPH:
      return "paragraph";
    case ACSTYPE_QUOTE:
      return "quote";
    case ACSTYPE_IMAGE:
      return "image";
    case ACSTYPE_VIDEO:
      return "video";
    case ACSTYPE_AUDIO:
      return "audio";
    case ACSTYPE_SEP:
      return "separator";
    case ACSTYPE_MAIN_IMG:
      return "image";
    case ACSTYPE_GALLERY:
      return "gallery";
    case ACSTYPE_MOSAIC:
      return "mosaic";
    case ACSTYPE_PREFACE:
      return "preface";
    default:
      return null;
  }
}

export function getClientACSType(acsTypeText) {
  switch (acsTypeText) {
    case "title":
      return ACSTYPE_TITLE;
    case "subtitle":
      return ACSTYPE_SUBTITLE;
    case "contributor":
      return ACSTYPE_CONTRIBUTOR;
    case "intro":
      return ACSTYPE_INTRO;
    case "h1":
      return ACSTYPE_SEC_TITLE;
    case "h2":
      return ACSTYPE_SEC_SUBTITLE;
    case "paragraph":
      return ACSTYPE_PARAGRAPH;
    case "quote":
      return ACSTYPE_QUOTE;
    case "image":
      return ACSTYPE_IMAGE;
    case "video":
      return ACSTYPE_VIDEO;
    case "audio":
      return ACSTYPE_AUDIO;
    case "separator":
      return ACSTYPE_SEP;
    case "gallery":
      return ACSTYPE_GALLERY;
    case "mosaic":
      return ACSTYPE_MOSAIC;
    case "preface":
      return ACSTYPE_PREFACE;
    default:
      return null;
  }
}
